import Cookies from 'utils/Cookies';

const SOT_TRACKING_ID_COOKIE = 'sti';

// The SOT (Sephora One Tag) library persists its tracking id in the 'sti' cookie
// (the same value SOT sends as session.sotTrackingId). It tracks both registered
// and anonymous GenAI clients, so it is sent as sot_tracking_id on GenAI requests.
// Returns '' when unavailable (SSR or cookie not yet set).
const getSotTrackingId = () => {
    try {
        return Cookies.read(SOT_TRACKING_ID_COOKIE) || '';
    } catch (e) {
        Sephora?.logger?.verbose(`SuperChat: failed to read the "${SOT_TRACKING_ID_COOKIE}" (sot_tracking_id) cookie:`, e);

        return '';
    }
};

export { SOT_TRACKING_ID_COOKIE };

export default getSotTrackingId;
